import globalEn from './global/global-en'
import loginEn from './login/login-en'
import homeEn from './home/home-en'
import deviceEn from './device/device-en'
import logEn from './logs/log-en'
import orgEn from './org/org-en'
import alarmEn from './alarm/alarm-en'
import superviseEn from './supervise/supervise-en'
import menuEn from './menu/menu-en'
import searchEn from './search/search-en'
import columnCheck from './columnCheck/columnCheck-en'
import setting from './setting/setting-en'
const en = {
  global: globalEn,
  login: loginEn,
  home: homeEn,
  alarm: alarmEn,
  device: deviceEn,
  org: orgEn,
  log: logEn,
  supervise: superviseEn,
  menu: menuEn,
  search: searchEn,
  columnCheck: columnCheck,
  setting: setting
}
export default en